/* eslint-disable import/prefer-default-export */
import axios, { AxiosResponse } from 'axios'

import { IColorSelected } from '../types/ICreateProps'

export const savePlate = (
  token: string,
  plate_id: string | undefined,
  title: string | null,
  colors: IColorSelected,
): Promise<AxiosResponse> => {
  const apiPath = `${process.env.REACT_APP_API_DOMAIN}${process.env.REACT_APP_SAVE_COLOR_ENDPOINT}`

  return axios
    .post(
      `${apiPath}`,
      { plate_id, title, colors },
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      },
    )
    .then((response: AxiosResponse) => response)
    .catch((error) => error)
}

export const getPlate = (
  token: string,
  plate_id: string | undefined,
): Promise<AxiosResponse> => {
  const apiPath = `${process.env.REACT_APP_API_DOMAIN}${process.env.REACT_APP_GET_COLOR_ENDPOINT}`

  return axios
    .get(`${apiPath}/${plate_id}`, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    })
    .then((response: AxiosResponse) => response)
    .catch((error) => error)
}

export const getAllUserPlates = (token: string): Promise<AxiosResponse> => {
  const apiPath = `${process.env.REACT_APP_API_DOMAIN}${process.env.REACT_APP_GET_ALL_PLATES}`

  return axios
    .get(`${apiPath}`, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    })
    .then((response: AxiosResponse) => response)
    .catch((error) => error)
}
